interface ToolCTAProps {
  headline: string;
  description: string;
  buttonText?: string;
  buttonHref?: string;
}

export default function ToolCTA({
  headline,
  description,
  buttonText = 'Get Started Free',
  buttonHref = 'https://app.superpowerresume.com/sign-up',
}: ToolCTAProps) {
  return (
    <section className="mt-16 bg-gradient-to-r from-blue-600 to-blue-500 rounded-2xl shadow-2xl px-8 py-12 flex flex-col items-center text-center">
      <h2 className="text-3xl font-extrabold mb-4 text-white tracking-tight">
        {headline}
      </h2>
      <p className="text-lg text-blue-100 mb-8 max-w-xl">
        {description}
      </p>
      <a
        href={buttonHref}
        className="inline-block bg-white text-blue-700 font-bold py-3 px-8 rounded-xl shadow text-lg hover:bg-blue-50 hover:scale-105 hover:shadow-xl transition-all duration-200"
      >
        {buttonText}
      </a>
      <p className="text-sm text-blue-200 mt-4">No credit card required</p>
    </section>
  );
}
